exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".NumberedItem__wrapper___3a4Fj {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row;\n        flex-direction: row;\n    margin-bottom: 40px;\n}\n\n.NumberedItem__number___3EYdq {\n    display: table;\n    background: #ff8e42;\n    color: white;\n    line-height: 40px;\n    width: 40px;\n    height: 40px;\n    min-width: 40px;\n    text-align: center;\n    border-radius: 20px;\n    margin-right: 40px;\n}\n\n.NumberedItem__contentWrapper___1wXRQ {\n    display: inline-block;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "NumberedItem__wrapper___3a4Fj",
	"number": "NumberedItem__number___3EYdq",
	"contentWrapper": "NumberedItem__contentWrapper___1wXRQ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/NumberedItem/NumberedItem.css
// module id = 391
// module chunks = 0